import React from "react";

function MidImage() {
  return (
    <div className="container">
      <div
        className="col-12"
        style={{
          textAlign: "center",
          backgroundColor: "white"
        }}
      />

      <div
        className="col-12"
        style={{
          textAlign: "center",
          margin: "auto",
          alignItems: "center",
          padding: "30px 0px 30px 0px"
        }}
      >
        <img
          src="/assets/images/upsy_help.svg"
          width="90%"
          alt="Upsy illustration"
        />
      </div>
    </div>
  );
}

export default MidImage;